import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Flex,
  Heading,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
} from "@chakra-ui/react";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { useGlobalFilter, usePagination, useSortBy, useTable } from "react-table";
import CountUpComponent from "common/components/countUpComponent";
import Pagination from "common/components/pagination/Pagination";
import { MdOutlineMessage } from "react-icons/md";
import { useNavigate, useParams } from "react-router-dom";
import AddPhoneCall from "common/modules/phoneCall/AddPhoneCall";
import { AddIcon } from "@chakra-ui/icons";
import DataNotFound from "common/components/notFoundData";
import DateFormatter from "common/utils/dateFormater";
import 'common/assets/css/viewEdit.css'
import { globalStyles } from "common/theme/styles";
import { crmConstant } from "services/Crm/constant";
import { constant } from "common/constant";
import useGlobalTable from "services/Crm/utils/tableInstance";

export default function PhoneCall(props) {
  const { columnsData, tableData, title, fetchData, callAccess, allData, isLead, initialValues, lead, dynamic = false } = props;
  const columns = useMemo(() => columnsData, [columnsData]);
  const data = useMemo(() => tableData, [tableData]);
  const [addModel, setAddModel] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const [gopageValue, setGopageValue] = useState();
  const param = useParams();
  const navigate = useNavigate();
  const textColor = useColorModeValue("gray.500", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
  const buttonbg = useColorModeValue("gray.200", "white");


  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    pageIndex, pageSize,
  } = useGlobalTable(columns, data);

     useEffect(() => {
    document.body.classList.add("bgWhiteImp");
    return () => {
      document.body.classList.remove("bgWhiteImp");
    };
  }, []);

  return (
    <>
      <Box className="viewEditAccordian">
        <Box className="viewEditAccordianItem">
          <Box className="viewEditAccordianBtn">
            <Flex justify="space-between" flex="1" align="center">
              <Flex gap={"20px"} alignItems={"center"}>
                <Heading className="viewEditAccordianHeader" size="md">
                  {title}
                  {/* (
                  <CountUpComponent
                    key={isLead ? allData?.phoneCall?.length : allData?.phoneCallHistory?.length}
                    targetNumber={isLead ? allData?.phoneCall?.length : allData?.phoneCallHistory?.length}
                  />
                  ) */}
                </Heading>
                {/* <AccordionIcon color={globalStyles.colors.iconDark}/> */}
              </Flex>

              {!props.text ? (
                callAccess?.create && (
                  <Button
                    size="sm"
                    // onClick={(event) => {
                    //   event.stopPropagation();
                    //   setAddModel(true);
                    // }}
                    onClick={() =>
                      navigate("/crm/phone-call/createCallLog", {
                        state: {
                          initialValuesProp: initialValues,
                          view: lead ? constant.lead : dynamic ? initialValues?.dealName ? constant.deals : constant.accounts : constant.contact,
                          dealAccountPhoneNumber: allData.account?.[0]?.phoneNumber
                        },
                      })
                    }

                    leftIcon={<AddIcon fontSize={"12px"} color={globalStyles.colors.iconDark} />}
                    className="accordianAddBtn"
                  >
                    {constant.addNew}
                  </Button>
                )
              ) : (
                <Button
                  onClick={() => navigate("/communication-integration")}
                  size="sm"
                  leftIcon={<MdOutlineMessage />}
                  className="accordianAddBtn"
                >
                  send text Msg
                </Button>
              )}

            </Flex>
          </Box>
          <Box className="viewEditAccordianPannel" pb={4}>

            <Box overflowY={"auto"} className="table-container">
              <Table {...getTableProps()} variant="simple" color="gray.500" mb="24px" className="lead-table-main">
                <Thead className="viewEditAccordian-tableHead">
                  {headerGroups?.map((headerGroup, index) => (
                    <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
                      {headerGroup.headers.map((column, index) => (
                        <Th
                          {...column.getHeaderProps(column.isSortable !== false && column.getSortByToggleProps())}
                          key={index}
                          borderColor={borderColor}
                        >
                          <Flex justifyContent={column.center ? "center" : "start"} align="center">
                            <span style={{ textTransform: "capitalize", marginRight: "8px" }}>{column.render("Header")}</span>
                          </Flex>
                        </Th>
                      ))}
                    </Tr>
                  ))}
                </Thead>
                <Tbody {...getTableBodyProps()}>
                  {data?.length === 0 && (
                    <Tr>
                      <Td colSpan={columns.length} textAlign="center" className="nodataTd">
                        <DataNotFound title={"Call logs"} />
                      </Td>
                    </Tr>
                  )}
                  {page?.map((row, index) => {
                    prepareRow(row);
                    const rowLink = props.text
                      ? `/text-msg/${row.original._id}`
                      : `/crm/phone-call/${row.original._id}`;

                    return (
                      <Tr
                        {...row?.getRowProps()}
                        key={index}
                        onClick={() => navigate(rowLink)}
                        cursor="pointer"
                        _hover={{ background: "gray.100" }}
                      >
                        {row?.cells.map((cell, index) => {
                          let data = "";
                          if (cell?.column.Header === crmConstant.callSubject) {
                            data = (
                              <Flex align="center">
                                <Text
                                  fontSize="sm"
                                  color={textColor}
                                  fontWeight="700"
                                >
                                  {cell?.value}
                                </Text>
                              </Flex>
                            );
                          } else if (cell?.column.Header === crmConstant.callType) {
                            data = (
                              <Flex align="center">
                                <Text
                                  me="10px"
                                  color="brand.600"
                                  fontSize="sm"
                                  fontWeight="700"
                                >
                                  {cell?.value}
                                </Text>
                              </Flex>
                            );
                          // } else if (cell?.column.Header === crmConstant.createdAt) {
                          //   data = (
                          //     <Text color={textColor} fontSize="sm" fontWeight="700">
                          //       {DateFormatter(cell?.row?.values.timestamp)}
                          //     </Text>
                          //   );
                          // } 
                            }  else if (cell?.column.Header === crmConstant.createdAt) {
  data = (
    <Text color={textColor} fontSize="sm" fontWeight="700">
      {DateFormatter(cell?.row?.original?.timestamp)}
    </Text>
  );
}
                           else if (cell?.column.Header === crmConstant.callDuration) {
                            data = (
                              <Text color={textColor} fontSize="sm" fontWeight="700">
                                {/* {moment(cell?.value).fromNow()} */}
                                 {moment.utc(cell?.value * 1000).format("mm:ss")}
                              </Text>
                            );
                          }
                          // else if (cell?.column?.Header === "Hidden Timestamp") return null;
                          return (
                            <Td
                              {...cell?.getCellProps()}
                              key={index}
                              fontSize={{ sm: "14px" }}
                              minW={{ sm: "150px", md: "200px", lg: "auto" }}
                              borderColor="transparent"
                            >
                              {data}
                            </Td>
                          );
                        })}
                      </Tr>
                    );
                  })}
                </Tbody>
              </Table>
            </Box>
            {data?.length > 5 && (
              <Pagination
                gotoPage={gotoPage}
                gopageValue={gopageValue}
                setGopageValue={setGopageValue}
                pageCount={pageCount}
                canPreviousPage={canPreviousPage}
                previousPage={previousPage}
                canNextPage={canNextPage}
                pageOptions={pageOptions}
                setPageSize={setPageSize}
                nextPage={nextPage}
                pageSize={pageSize}
                pageIndex={pageIndex}
              />
            )}
          </Box>
        </Box>
      </Box>
      <AddPhoneCall lead={props.lead} fetchData={fetchData} isOpen={addModel} onClose={setAddModel} id={param.id} />
    </>
  );
}